<template>
  <div class="device-settings">
    <div class="device-settings-wrapper">
      <img src="/static/img/device-settings/thumb-device-settings.svg" class="thumb" width="363" height="299" />
      <h1>GENERAL SETTINGS</h1>
      <form @submit.prevent="onSubmit()">
        <!-- <div class="field">
          <div class="fieldinput fieldselect">
            <select v-model="device">
              <option value="" disabled selected>Select Device</option>
              <template v-for="item in deviceoption">
                <option :value="item.id">{{item.value}}</option>
              </template>
            </select>
          </div>
        </div> -->
        <!-- <div class="field">
          <div class="fieldinput fieldselect">
            <select v-model="screen">
              <option value="" disabled selected>Select Screen</option>
              <template v-for="(item, i) in screenoption">
                <option :key="i" :value="item">{{ item.value }}</option>
              </template>
            </select>
          </div>
        </div> -->

        <SelectScreenFrom
          tabindex="0"
          :lists="screenoption"
          :is-screen="true"
          :type="'store'"
          :selected="screen"
          title="Select Screen"
          field="value"
          @change="changeScreen($event)"
        />

        <div v-if="loading_data || loading_stores" class="field">
          <div class="fieldinput fieldselect">
            <div id="loaderspinwrap" class="loaderspinwrap form-loader"><div class="loaderspin"></div></div>
          </div>
        </div>
        <div v-else class="field">
          <!-- <div class="fieldinput fieldselect">
            <select v-model="location" @change="changeLocation($event)">
              <option value="" disabled selected>Select Location</option>
              <template v-if="screen.key === 'vmcola'">
                <template v-for="(item,j) in location_vmcola">
                  <option :value="j" :key="j">{{item.name}}</option>
                </template>
              </template>
              <template v-else>
                <template v-for="(item,k) in locationoption">
                  <option :value="k" :key="k">{{item.name}}</option>
                </template>
              </template>
            </select>
          </div> -->
          <SelectDeviceFrom
            tabindex="0"
            :loading="loading_pagination"
            :lists="list_options"
            :type="
              screen && screen.key == 'vmcola'
                ? 'vmcola'
                : screen && screen.key == 'checkin-station-event'
                ? 'checkin-station-event'
                : 'store'
            "
            :selected="location"
            title="Select Location"
            field="name"
            @change="changeLocation($event)"
            @load-more="doCallback"
            @onType="onTypingSelectLocation"
          />
        </div>
        <button
          v-if="screen !== '' && location !== '' && location !== -1"
          tabindex="0"
          type="submit"
          class="submit btn button"
        >
          <template v-if="!loading"> SUBMIT </template>
          <div v-else id="loaderspinwrap" class="loaderspinwrap"><div class="loaderspin"></div></div>
        </button>
        <button v-else tabindex="0" type="submit" class="submit btn button" disabled>SUBMIT</button>
      </form>
    </div>
  </div>
</template>

<script>
import ls from '@/components/helpers/local-storage';
// import SelectDeviceFrom from '@/components/global/select-device-form';
export default {
  name: 'DeviceSettings',
  components: {
    SelectScreenFrom: () => import('@/components/global/select-device-form'),
    SelectDeviceFrom: () => import('@/components/global/select-device-form'),
  },
  data() {
    return {
      device: '',
      screen: '',
      location: '',
      deviceoption: [
        { id: 1, value: 'iPad 6' },
        { id: 2, value: 'Full HD TV' },
      ],
      screenoption: [
        { id: 1, key: 'checkin-station', value: 'Check-In Station - Store', url: '/checkin-station-event/store/home' },
        {
          id: 2,
          key: 'checkin-station-event',
          value: 'Check-in Station - Event',
          url: '/checkin-station-event/event/home',
        },
        { id: 3, key: 'self-checkout', value: 'Self Checkout', url: '/self-checkout/home' },
        { id: 4, key: 'lipstick-bar', value: 'Lipstick Bar', url: '/lipstickbar/home' },
        { id: 5, key: 'ranking', value: 'Ranking', url: '/ranking/' },
        { id: 6, key: 'recommendation-machine', value: 'Recommendation Machine', url: '/recommendation/splash' },
        { id: 7, key: 'register', value: 'Register', url: '/register/' },
        { id: 8, key: 'smart-mirror', value: 'Smart Mirror', url: '/smart-mirror/' },
        { id: 9, key: 'soco-mask-station', value: 'Soco Mask Station', url: '/mask-station/home' },
        { id: 10, key: 'vending-machine', value: 'Vending Machine', url: '/vending-machine/home' },
        { id: 11, key: 'vmcola', value: 'VM Cola', url: '/vmcola' },
        { id: 12, key: 'big-bang-boom-vn', value: 'Big Bang Boom VN', url: '/vending-machine-vn/home?isvn=true' },
        { id: 13, key: 'checkin-station-vn', value: 'CheckIn Station VN', url: '/checkin-station/home?isvn=true' },
        { id: 14, key: 'checkin', value: 'CheckIn', url: '/checkin/' },
        { id: 15, key: 'dandelion-store', value: 'Dandelion - Price Checker', url: '/dandelion-store' },
        { id: 16, key: 'dandelion-store-vn', value: 'Dandelion - Price Checker VN', url: '/dandelion-store-vn' },
        { id: 21, key: 'dandelion-store-sg', value: 'Dandelion - Price Checker SG', url: '/dandelion-store-sg' },
        {
          id: 17,
          key: 'soco-vending-machine-event',
          value: 'Soco Vending Machine Event',
          url: '/soco-vending-machine-event/home',
        },
        {
          id: 18,
          key: 'cosrx-vending-machine-event',
          value: 'Soco Vending Machine Games - Cosrx',
          url: '/cosrx-vending-machine-event',
        },
        {
          id: 19,
          key: 'blind-box',
          value: 'Blind Box',
          url: '/blind-box',
        },
        {
          id: 20,
          key: 'laka-vending-machine-event',
          value: 'Soco Vending Machine Event - Laka',
          url: '/laka-vending-machine-event/home',
        },
      ],
      // locationoption: [],
      // location_vmcola: [],
      locationVmColaDetail: '',
      locationCheckinStationEvent: '',
      loading: false,
    };
  },
  computed: {
    loading_stores() {
      return this.$store.state.loading_stores;
    },
    loading_data() {
      return this.$store.state.loading_vmcola;
    },
    loading_pagination() {
      return this.$store.state.loading_pagination;
    },
    locationoption() {
      return this.$store.state.stores;
    },
    location_vmcola() {
      return this.$store.state.vmcola;
    },
    location_checkin_station_event() {
      return this.$store.state.checkinStation.checkinStationList;
    },
    list_options() {
      if (this.screen && this.screen.key === 'dandelion-store-sg') {
        return this.$store.state.storesSg;
      }
      return this.screen &&
        (this.screen.key == 'vmcola' ||
          this.screen.key == 'soco-vending-machine-event' ||
          this.screen.key == 'cosrx-vending-machine-event' ||
          this.screen.key == 'laka-vending-machine-event' ||
          this.screen.key == 'blind-box')
        ? this.location_vmcola
        : this.screen && this.screen.key == 'checkin-station-event'
        ? this.location_checkin_station_event
        : this.locationoption;
    },
  },
  watch: {
    screen(val) {
      this.location = -1;
      if (
        val.key === 'vmcola' ||
        val.key === 'soco-vending-machine-event' ||
        val.key === 'blind-box' ||
        val.key === 'cosrx-vending-machine-event' ||
        val.key === 'laka-vending-machine-event'
      ) {
        // this.getVmStore()
        this.$store.dispatch('getVmStores');
      }
      if (val.key === 'checkin-station-event') {
        this.$store.dispatch('fetchCheckinStationList');
      }
      if (val.key === 'dandelion-store-sg') {
        this.$store.dispatch('getPhysicalStoresSg');
      }
      if (val.key === 'dandelion-store-vn') {
        this.$store.dispatch('getPhysicalStoresVn');
      }
    },
  },
  created() {
    this.$store.dispatch('VendingMachineDevice', false);

    this.resetCartVmCola();
    if (this.$route.name == 'DeviceSettings') {
      // this.getVmStore()
      this.$store.dispatch('getPhysicalStores');
    }
    // this.locationoption = Config.store_lists
  },
  methods: {
    onTypingSelectLocation(params) {},
    onSubmit() {
      this.loading = true;
      let store_key =
        this.screen.key == 'vmcola' ||
        this.screen.key == 'blind-box' ||
        this.screen.key == 'soco-vending-machine-event' ||
        this.screen.key == 'cosrx-vending-machine-event' ||
        this.screen.key == 'laka-vending-machine-event'
          ? 'store_id'
          : '_id';
      if (['checkin-station', 'lipstick-bar'].includes(this.screen.key)) {
        store_key = 'id';
      }
      const loc = store_key ? this.list_options[this.location][store_key] : this.location;
      const store_alias = this.list_options[this.location]['alias'];

      this.setStoreDetail(this.list_options[this.location]);

      if (this.screen.key === 'vending-machine') {
        this.$store.dispatch('VendingMachineDevice', true);
      }

      this.$store.dispatch('saveStoreIdCookies', loc);
      this.setVmColaLocDetail();

      setTimeout(
        function () {
          if (this.screen.key === 'checkin-station-event') {
            this.$router.push(`checkin-station-event/event/${this.locationCheckinStationEvent._id}`);
          } else if (this.screen.key === 'checkin-station') {
            this.$router.push(`checkin-station-event/store/${this.locationCheckinStationEvent._id}`);
          } else if (['dandelion-store', 'dandelion-store-vn', 'dandelion-store-sg'].includes(this.screen.key)) {
            const url = `${this.screen.url}/${store_alias}`;
            window.open(url, '_blank');
            this.loading = false;
          } else {
            this.$router.push(this.screen.url);
          }
        }.bind(this),
        400
      );
    },
    setVmColaLocDetail(value) {
      this.$store.dispatch('vmColaLocationDetailCookies', this.locationVmColaDetail);
    },
    setStoreDetail(val) {
      this.$store.dispatch('saveStoreDetail', val);
    },
    changeScreen($event) {
      const selected_screen = this.screenoption.find((sc) => sc.id === $event.target.id);
      if (selected_screen) {
        this.screen = selected_screen;
      }
    },
    changeLocation(event) {
      const target = event.target.value;
      this.location = target;
      const loc = target > -1 ? this.list_options[target] : '';
      const isSetVmColaDetail =
        this.screen.key === 'vmcola' ||
        this.screen.key === 'cosrx-vending-machine-event' ||
        this.screen.key === 'laka-vending-machine-event';
      if (isSetVmColaDetail && Object.keys(loc).length) {
        this.locationVmColaDetail = loc;
      } else if (this.screen.key == 'checkin-station-event' || this.screen.key == 'checkin-station') {
        this.locationCheckinStationEvent = loc;
      } else {
        this.locationVmColaDetail = '';
      }
    },
    resetCartVmCola() {
      ls.remove('cart');
      this.$store.dispatch('resetCart', 0);
    },
    doCallback(type) {
      if (type == 'store' && this.screen.key == 'dandelion-store-vn') {
        this.$store.dispatch('getPhysicalStoresVn', true);
      }
      if (type == 'store' && this.screen.key == 'dandelion-store-sg') {
        this.$store.dispatch('getPhysicalStoresSg', true);
        return;
      }
      if (
        type == 'vmcola' ||
        this.screen.key == 'soco-vending-machine-event' ||
        this.screen.key == 'cosrx-vending-machine-event' ||
        this.screen.key == 'laka-vending-machine-event'
      ) {
        this.$store.dispatch('getVmStores', true);
      } else if (type == 'checkin-station-event') {
        this.$store.dispatch('fetchCheckinStationList', true);
      } else {
        this.$store.dispatch('getPhysicalStores', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './device-settings';
</style>
